import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';
import type {Disposable, Environment} from 'relay-runtime';
import type {MutationInput} from './MutationTypes';
import type {
	MigrateXeroClientsMutation,
	MigrateXeroClientsMutation$data,
	MigrateXeroClientsMutation$variables,
} from './__generated__/MigrateXeroClientsMutation.graphql';

const mutation = graphql`
	mutation MigrateXeroClientsMutation($input: MigrateXeroClientsInput!) {
		migrateXeroClients(input: $input) {
			unlinkedBillToCount
			company {
				clients(first: 10000) {
					edges {
						node {
							id
							name
							notes
							logoId
							logoDefaultId
							projectCount
							xeroContactId
						}
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<MigrateXeroClientsMutation$variables['input']>,
	onSuccess?: (response: MigrateXeroClientsMutation$data) => void,
	onError?: (error: Error) => void
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<MigrateXeroClientsMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
